import React from 'react';

export default function FormatText({ text }) {
  // 將文字按換行字符拆分成陣列
  const lines = text.split('\n');
  // 如果有網址，則將網址轉換成連結
  const formattedLines = lines.map((line) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return line.replace(
      urlRegex,
      '<a href="$1" target="_blank" style="text-decoration: underline; color: blue;">$1</a>',
    );
  });

  return (
    <div>
      {formattedLines.map((line, index) => (
        <React.Fragment key={index}>
          <span dangerouslySetInnerHTML={{ __html: line }}></span>
          {index !== lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </div>
  );
}
